export const baseUrl = process.env.REACT_APP_API_URL;
export const swizzleUrl = process.env.REACT_APP_SWIZZLE_URL
export const apiKey = process.env.REACT_APP_API_KEY;
export const appSecretKey = process.env.REACT_APP_SECRET_KEY;

export const phoneRegex = /^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})( | -)?[2-9]\d{2}-?\d{4}$/;
export const emailRegEx = /^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
export const noSpaceRegex = /^(?!\s*$).+/;
export const bankAccountRegex = /^\d{8,16}$/;
export const indianZipRegEx = /^[1-9][0-9]{5}$/;
export const numberLetterRegExp = /^[a-zA-Z0-9]+$/;
export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  export const convertToLowerCase = (string) => {
    return string.toLowerCase();
  };
const user = localStorage.getItem('user');
const data = JSON.parse(user)

export const sidebarData = [
    {
        type:'dashboard',
        title:'Dashboard',
        link:'dashboard',
        icon: 'home',
        is_show:true
    },
    {
      type:'estimates',
      title:'Estimates',
      link:'estimates',
      icon: 'receipt',
      is_show:true
    },
    {
        type:'invoices',
        title:'Invoices',
        link:'invoices',
        icon: 'receipt_long',
        is_show:true
    },
   
    {
        type:'customers',
        title:'Customers',
        link:'customers',
        icon: 'groups',
        is_show:true
    },
    {
      type:'notifications',
      title:'Notifications',
      link:'notifications',
      icon: 'notifications',
      is_show:true
  },
    {
        type:'settings',
        title:'Settings',
        link:'settings',
        icon: 'settings',
        is_show:true
    },
    {
      type:'otplogs',
      title:'Otp Logs',
      link:'otplogs',
      icon: 'list_alt',
      is_show:false,
      phone:'7025171538'
    },
    {
      title:'Estimate',
      link:'estimate',
      is_show:false
  },
  {
    title:'Payment',
    link:'invoice',
    is_show:false
},
]
